import React from 'react';
import FinicityLinkContent from './FinicityLinkContent';
import { FinicityLinkProvider } from './FinicityLinkContext';

export const FINICITY_CONNECT_ELEMENT_ID = 'container-finicity-connect';

const Finicity = ({ resource, onLoadLink, ...rest }) => {
  return (
    <FinicityLinkProvider resource={resource} onLoadLink={onLoadLink}>
      <FinicityLinkContent
        resource={resource}
        {...rest}
      />
    </FinicityLinkProvider>
  );
};

export default Finicity;
